<template>
  <main class="main-content m-t-3 m-b-3">
    <notification></notification>
    <dash :user="user" :top-artists="topArtists" :recent-tracks="recentTracks" :recommendet-tracks="recommendetTracks"></dash>
    <action-footer></action-footer>
  </main>
</template>

<script>
import {bus} from '../main'
import { apiInterface } from '../mixins/apiInterface';
import Dash from '../components/dashboard/Dash';
import Notification from '../components/shared/Notification';
import actionFooter from '../components/shared/ActionFooter';
export default {
  name: 'Home',
  data: () => {
    return {
      accessToken: false,
      user: false,
      topArtists: false,
      recentTracks: false,
      recommendetTracks: false,
    }
  },
  mixins: [apiInterface],
  components: {
    Dash,
    Notification,
    actionFooter
  },
  methods: {
    setUserProfile() {
      this.getApiResource('/me', this.accessToken)
      .then(response => {
        const { country, display_name, email, href, id, type } = response;
        this.user = { country, display_name, email, href, id, type };
      });
    },
    setTopArtists() {
      this.getApiResource('/me/top/artists', this.accessToken)
      .then(response => {
        const {items: artists} = response;
        this.topArtists = artists;
      });
    },
    getRecentTracks() {
      this.getApiResource('/me/player/recently-played', this.accessToken)
      .then(response => {
        this.recentTracks = response.items;
      });
    },
    getRecommendedTracks(recParams) {
      const {selectedArtists} = recParams;
      const seedArtists = this.createSeedArtists(selectedArtists);
      this.getApiResource(`/recommendations?seed_artists=${seedArtists}`, this.accessToken)
      .then(response => {
        this.recommendetTracks = response.tracks;
      });
    },
    createSeedArtists(artists){
      return artists.join(',');
    },
    handleRecommendedReset(){
      this.recommendetTracks = false;
    },
  },
  created() {
    if (this.$route.params.accessToken) {
      this.accessToken = this.$route.params.accessToken;
      this.setTopArtists();
      this.setUserProfile();
      this.getRecentTracks();
    }
    bus.$on('resetRecs', this.handleRecommendedReset);
    bus.$on('fetchRecs', this.getRecommendedTracks);
  }
}
</script>

<style scoped>
  .main-content {
    width: 100%;
    padding: 0 3rem;
    height: calc(100vh - 6rem);
  }
  @media screen and (max-width: 1024px) {
    .main-content {
      padding: 0 0rem;
      height: initial;
    }
  }
</style>